export const columnNamesSelector = (state) => state.news.columnNames;
export const dataGridSelector = (state) => state.news.dataGrid;
export const dataGridLoaderSelector = (state) => state.news.dataGridLoader;
export const selectedNewsSelector = (state) => state.news.selectedNewsRow;
export const ficheNewsSelector = (state) => state.news.ficheNews;
export const ficheNewsFormSelector = (state) => state.news.ficheNewsForm;
export const loaderficheNewsSelector = (state) => state.news.ficheNewsLoader;
export const newsSuiviSelector = (state) => state.news.newsSuivi;
